export const Shading = {
  FLAT: 0,
  GOURAUD: 1,
  PHONG: 2,
};

export const Representation = {
  POINTS: 0,
  WIREFRAME: 1,
  SURFACE: 2,
};

export const Interpolation = Shading;

export default {
  Shading,
  Representation,
  Interpolation,
};
